module.exports = __webpack_public_path__ + "img/wisdomleads-qc.77f5472f.png";